<template lang="pug">
  .col-12.col-sm-6.col-md-6.col-lg-3.blog-list__item
    header.blog-list__item-header
      .blog-list__item-thumbnail
        router-link.blog-list__item-link(:to="{ name: 'blog.single', params: { slug: post.post_name } }")
          img.blog-list__item-thumbnail-image.d-block.d-lg-none(
            :src='post.mobile_responsive_cover.url' alt=''
            v-if="post.mobile_responsive_cover && post.mobile_responsive_cover.url"
          )
          img.blog-list__item-thumbnail-image(
            :src='post.image' alt=''
            v-bind:class="{'d-none d-lg-block': post.mobile_responsive_cover && post.mobile_responsive_cover.url}"
          )
    section.blog-list__item-body
      .blog-list__item-tags
        router-link.blog-list__item-tag(:to="{ name: 'blog.category.index', params: { slug: post.main_category_slug } }") {{ post.main_category }}
      router-link.blog-list__item-link(:to="{ name: 'blog.single', params: { slug: post.post_name } }")
        h5.blog-list__item-title {{ post.post_title }}
      p.blog-list__item-description
        | {{ post.short_description }}
</template>

<script>
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
};
</script>
